import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Box from '@mui/material/Box';
import { useAuthContext } from '../contexts/authContext';
import PublicRoute from './publicRoute';
import PrivateRoute from './privateRoute';
import {
    EXPIRATIONTOKEN,
    PAGENOTFOUND,
    HOME,
    SIGNIN,
    USERS,
    USERLIST,
    USERNEW,
    USEREDIT,
    SURVEY_PATH,
    SURVEYNEW,
    SURVEYEDIT,
    EXPORT,
} from './paths';
import { ModulesSideBar } from '../components/components/navbar/components';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { esES } from '@mui/material/locale';
import variables from '../shared/styles/settings.module.scss';
import SignIn from '../components/pages/auth/signIn';
import NavBar from '../components/components/navbar/navbar';
import UserList from '../components/pages/users/list';
import UserNew from '../components/pages/users/new';
import EditUser from '../components/pages/users/edit';
import ExpirationToken from '../components/components/views/expirationToken';
import PageNotFound from '../components/components/views/pageNotFound';
import SurveyList from '../components/pages/surveys/list';
import SurveysFormView from '../components/pages/surveys/render';
import SurveyNew from '../components/pages/surveys/new';
import SurveyEdit from '../components/pages/surveys/edit';
import Export from '../components/pages/export';

const AppRoutes = () => {
    const { tokenAuth, modeTheme, showNavbar } = useAuthContext();

    const theme = createTheme(
        {
            palette:
                modeTheme === 'darkMode'
                    ? {
                        // palette values for dark mode
                        primary: {
                            main: variables.whiteColor,
                            contrastText: variables.darkColor,
                            dark: variables.greyColor,
                        },
                        text: {
                            primary: variables.darkColor,
                            secondary: variables.greyColor,
                        },
                    }
                    : {
                        // palette values for light mode
                        primary: {
                            main: variables.primaryColor,
                            contrastText: variables.whiteColor,
                            dark: variables.quinaryColor,
                        },
                        text: {
                            primary: variables.darkColor,
                            secondary: variables.greyColor,
                        },
                    },
            breakpoints: {
                values: {
                    xs: 0,
                    sm: 500,
                    md: 800,
                    lg: 1200,
                    xl: 1536,
                },
            },
        },
        esES
    );

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Box sx={{ flexGrow: 1, display: 'block' }}>
                    {tokenAuth && showNavbar && (
                        <NavBar modules={ModulesSideBar} />
                    )}

                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            mt: tokenAuth && showNavbar && 10,
                            ml: tokenAuth && showNavbar && 10,
                            color: 'primary.main',
                        }}
                    >
                        <Routes>
                            <Route path={HOME} element={<PrivateRoute />}>
                                <Route index element={<SurveyList />} />
                            </Route>
                            <Route path={SURVEYNEW} element={<SurveyNew />} />
                            <Route
                                path={`${SURVEYEDIT}/:idSurvey`}
                                element={<SurveyEdit />}
                            />
                            <Route path={USERS} element={<PrivateRoute />}>
                                <Route path={USERLIST} element={<UserList />} />
                                <Route path={USERNEW} element={<UserNew />} />
                                <Route
                                    path={`${USEREDIT}/:idUser`}
                                    element={<EditUser />}
                                />
                            </Route>
                            <Route path={EXPORT} element={<PrivateRoute />}>
                                <Route path={EXPORT} element={<Export />} />
                            </Route>
                            <Route path={SIGNIN} element={<PublicRoute />}>
                                <Route index element={<SignIn />} />
                                <Route
                                    path={EXPIRATIONTOKEN}
                                    element={<ExpirationToken />}
                                />
                            </Route>
                            <Route
                                path={PAGENOTFOUND}
                                element={<PageNotFound />}
                            />
                            <Route
                                path={`${SURVEY_PATH}/:idSurvey`}
                                element={<SurveysFormView />}
                            />
                        </Routes>
                    </Box>
                </Box>
            </Router>
        </ThemeProvider>
    );
};

export default AppRoutes;
